import { WjInputModule } from '@grapecity/wijmo.angular2.input';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { KYMW0301Module } from './../kymw0301/kymw0301.module';
import { KYMW0300Component } from './kymw0300.component';
import { GetFeatureCodeListService } from './api-services/get-feature-code-list.service';


/**
 * 商品検索画面 モジュール設定クラス
 *
 * @export KYMW0300Module
 * @class KYMW0300Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjGridModule,
    WjNavModule,
    WjInputModule,
    KYMW0301Module,
  ],
  declarations: [
    KYMW0300Component,
  ],
  providers: [
    GetFeatureCodeListService,
  ],
})
export class KYMW0300Module {
}
